<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!--for overlay :loading="get_ay_std_ft_loader" -->
        <!--api- 1  -->
        <v-card v-if="fees_structure_data!=null" class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Fees Structure</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Fees Structure</h3>
                    </v-col>
                </v-row> -->
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="current_academic_year" :items="fees_structure_data.academic_year_list" item-text="Academic Year" label="Academic Year" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="std" :items="fees_structure_data.standard_list" item-text="Standard" label="Standard" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="fees_type" :items="fees_structure_data.fees_deposite_type" item-text="Fees Type" label="Fees Type" @click="putnull" outlined />
                    </v-col>
                    <v-col sm="2" v-if="fees_type == 'Admission Fees'">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="quota" :items="fees_structure_data.quota_list" item-text="qname" item-value="qid" label="Quota" outlined @click="putnull" />
                    </v-col>

                    <v-col sm="2">
                        <v-btn class="button mt-6" @click="getFeeStructureAndComponent" :loading="fetch_btn_load">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- api-1 ends -->
        <br />
        <!-- api-2 -->
        <v-card v-if="component_list!=null" class="box">
            <v-card-text>
                <v-form v-model="isValid">
                    <v-row justify="center">
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <v-combobox
                                dense
                                rounded
                                :required="true"
                                v-model="component"
                                :items="component_list"
                                item-text="Component"
                                label="Component"
                                outlined
                                :rules="component_list? [ v =>!!v || ' Component is required']: [] "
                            />
                        </v-col>
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <v-text-field
                                rounded
                                outlined
                                dense
                                :required="true"
                                v-model="comp_amount"
                                label="Amount"
                                type="number"
                                hint="For example :: 1000"
                                :rules="comp_amount < 0 || comp_amount==null || comp_amount=='' ? [' Amount is required']: []"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <!-- <v-combobox
                                rounded
                                dense
                                :required="true"
                                v-model="order"
                                :items="order_list"
                                item-text="Order"
                                :rules="order < 0 || order==null || order==''? [' Order is required']: []"
                                label="Order"
                                outlined
                            /> -->
                            <v-text-field
                                rounded
                                outlined
                                dense
                                :required="true"
                                v-model="order"
                                label="Order"
                                type="number"
                                hint="For example :: 1"
                                :rules="order < 0 || order==null || order==''
                                ? [' Order is required']
                                    : []
                                "
                            ></v-text-field>
                        </v-col>
                        <v-col sm="2">
                            <v-btn class="button mt-7" @click="addComponent" :disabled="!isValid" :loading="add_btn_load">Add</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-text v-if="comp_breakup_list.length!=0">
                <v-simple-table class="mytable elevation-1" dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Order</th>
                                <th>Component Name</th>
                                <th>Amount</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="comp in comp_breakup_list" :key="comp.id">
                                <td>{{comp.sortorder}}</td>
                                <td>{{comp.feescomponent}}</td>
                                <td>{{comp.amount}}</td>
                                <td>
                                    <v-avatar style size="25" class="edit-avatar">
                                        <v-icon class="edit-v-icon mr-2" @click="editItem(comp)" title="edit" style>edit</v-icon>
                                    </v-avatar>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-text v-if="fees_structure_master!=null">
                <v-row justify="end" style="margin-right: 35%;"><span class="font-weight-medium">Total:{{fees_structure_master.total_fees_amount}}</span></v-row>
                <v-row justify="center">
                    Concession amount:{{fees_structure_master.concession_amount}}
                    <br />
                    Concession date:{{fees_structure_master.concession_deadline}}
                    <span style="width: 15px;"> </span> <v-btn class="button" small @click="dialog2=true"><v-icon>mdi-plus</v-icon></v-btn>
                </v-row>
                <v-row justify="end" style="margin-right: 32%;"><span class="font-weight-medium">Grand total:{{fees_structure_master.total_fees_amount-fees_structure_master.concession_amount}}</span></v-row>
            </v-card-text>
        </v-card>
        <!-- api 2 ends -->
        <!-- Model pop up Edit Fees Component-->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card class="mx-auto">
                <v-card-title class="toolbar">
                    Edit Fees Component
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined rounded dense v-model="editedItem.sortorder" label="Sortorder" persistent-hint name="sortorder"> </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field outlined rounded dense v-model="editedItem.feescomponent" label="Fees Component"  name="feescomponent" disabled filled hint="noneditable" persistent-hint> </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field outlined rounded dense v-model="editedItem.amount" label="Amount" type="number" name="amount"> </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="dialog = false">Close</v-btn>
                    <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--/. End Model -->

        <!-- Model pop up Edit Concession amount/date-->
        <v-dialog v-model="dialog2" max-width="500px">
            <v-card class="mx-auto">
                <v-card-title class="toolbar">
                    Edit Concession
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field rounded dense v-model="concession_amount" label="Concession Amount" outlined name="concession_amount"> </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        v-model="concession_deadline"
                                        name="concession_deadline"
                                        hint="DD/MM/YYYY"
                                        persistent-hint
                                        label="Deadline Date"
                                        @blur="date = parseDate(concession_deadline)"
                                        v-on="on"
                                        rounded
                                        outlined
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="dialog2 = false">Close</v-btn>
                    <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--/. End Model -->
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            isValid: true,
            dialog: false,
            dialog2: false,
            //1
            fees_structure_data: null,
            current_academic_year: null,
            fees_type: null,
            quota_list: [],
            quota: null,
            std: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            //2
            comp_breakup_list: [],
            component_list: null,
            component: null,
            order_list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            comp_amount: 0,
            order: 1,
            fees_structure_master: null,
            add_btn_load: false,
            //loader
            get_ay_std_ft_loader: true,
            fetch_btn_load: false,
            editedIndex: -1,
            editedItem: {
                sortorder: "",
                feescomponent: "",
                amount: "",
                comp_breakup_id: "",
            },
            concession_amount: "",
            concession_deadline: "",
            // editedConcession:{
            //   id:'',
            //   concession_amount:'',
            //   concession_deadline:''
            // },
            date: new Date().toISOString().substr(0, 10),
            menu1: false,
        }),
        methods: {
            putnull() {
                this.component_list = null;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            save() {
                if (this.editedIndex > -1) {
                    for(let i=0;i<this.comp_breakup_list.length;i++){
                        if(this.comp_breakup_list[i].sortorder == this.editedItem.sortorder){
                           // alert("in if")
                            this.showSnackbar("#b71c1c", "Order already present!!!"); // show snackbar on error
                            return
                        }
                    }
                    axios
                        .post("/feesMaster/editComponent", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                Object.assign(this.comp_breakup_list[this.editedIndex], this.editedItem);
                                // this.comp_breakup_list = res.data.comp_breakup_list;
                                console.log("11111111")
                                console.log(this.comp_breakup_list)
                                alert(this.editedItem.sortorder)
                                this.showSnackbar("#4caf50", "Component updated Successfully!!!"); // show snackbar on success
                                this.getFeeStructureAndComponent();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on error
                                //error
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on error
                            window.console.log(error);
                        })
                        .finally(() => {
                            //close loader
                            this.fetch_btn_load = false;
                        });
                    this.dialog = false;
                } else {
                    const data = {
                        fees_structure_master: this.fees_structure_master.id,
                        concession_amount: this.concession_amount,
                        concession_deadline: this.concession_deadline,
                        // concession_data:this.editedConcession
                    };
                    axios
                        .post("/feesMaster/addEditConcessionAmount", data)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.addComponent();
                                this.showSnackbar("#4caf50", "Concession Amount added Successfully!!!"); // show snackbar on success
                                this.dialog2 = false;
                                //this.component = this.component_list[0];
                            } else if (res.data.status.code == "NA") {
                                //console.log(res.data.msg)
                                this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on error
                                this.dialog2 = false;
                                //error
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            window.console.log(error);
                        })
                        .finally(() => {
                            //close loader
                            this.fetch_btn_load = false;
                        });
                    this.dialog2 = false;
                }
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            editItem(item) {
                this.editedIndex = this.comp_breakup_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            // editFeesComponent(comp){
            // this.editedIndex = this.comp_breakup_list.indexOf(item)
            // this.editedItem = Object.assign({}, comp)
            // // this.dialog = true
            // // const formData = {
            // //     ay: this.current_academic_year,
            // //     fees_type: this.fees_type,
            // //     std: this.std,
            // //     comp:this.editedItem
            // //   };
            //   axios
            //   .post("/feesMaster/editComponent", this.editedItem)
            //     .then(res => {
            //       if (res.data.msg == "200") {
            //         alert("Component edited successfully!")
            //         //this.component = this.component_list[0];
            //       } else {
            //         alert("ERROR while editing!!!!!")
            //         //error
            //       }
            //     })
            //     .catch(error => {
            //       window.console.log(error);
            //     })
            //     .finally(() => {
            //       //close loader
            //       this.fetch_btn_load = false;
            //     });
            // },
            // addConcession(fees_structure_master) {
            //   // api-4  -> will call api-2
            //   /*alert(
            //     fees_structure_master.id +
            //       "--" +
            //       fees_structure_master.concession_amount
            //   );*/
            //   this.editedConcession = Object.assign({}, fees_structure_master)
            //   this.dialog2 = true
            //   axios
            //   .post("/feesMaster/addEditConcessionAmount", this.editedConcession)
            //     .then(res => {
            //       if (res.data.msg == "200") {
            //         //alert("Concession Amount added successfully!")
            //         this.dialog2 = false
            //         this.showSnackbar("#4caf50", "Component changed Successfully!!!"); // show snackbar on success
            //         this.get_ay_std_ft();
            //         //this.component = this.component_list[0];
            //       } else {
            //         this.showSnackbar("#b71c1c", "Language Already Present!!!"); // show snackbar on error
            //         this.dialog2 = false
            //         //error
            //       }
            //     })
            //     .catch(error => {
            //       window.console.log(error);
            //     })
            //     .finally(() => {
            //       //close loader
            //       this.fetch_btn_load = false;
            //     });
            // },
            addComponent() {
                // api-3  -> will call api-2
                if(this.comp_breakup_list!= null || this.comp_breakup_list!= ''){
                     for(let i=0;i<this.comp_breakup_list.length;i++){
                        if(this.comp_breakup_list[i].sortorder == this.order){
                           // alert("in if")
                            this.showSnackbar("#b71c1c", "Order already present!!!"); // show snackbar on error
                            return
                        }
                    }
                }
                add_btn_load: true;
                const formData = {
                    fees_structure_master_id: this.fees_structure_master.id,
                    comp_amount: this.comp_amount,
                    order: this.order,
                    component: this.component,
                };
                axios
                    .post("/feesMaster/addComponent", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.component = null;
                            this.order = parseInt(this.order) + 1;
                            this.getFeeStructureAndComponent(); //calling api-2
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.add_btn_load = false;
                    });
            },
            getFeeStructureAndComponent() {
                //api-2
                //alert(this.fees_type)
                let quota;
                if (this.fees_type == "Admission Fees") {
                    quota = this.quota;
                } else {
                    quota = "NA";
                }
                this.fetch_btn_load = true;
                const formData = {
                    ay: this.current_academic_year,
                    fees_type: this.fees_type,
                    std: this.std,
                    quota: quota,
                };
                axios
                    .post("/feesMaster/getFeeStructureAndComponent", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.component_list = res.data.component_list;
                            this.comp_breakup_list = res.data.comp_breakup_list;
                           // alert(res.data.order)
                            this.order = res.data.order
                            this.fees_structure_master = res.data.fees_structure_master;
                            //console.log("fees_structure_master>>"+this.fees_structure_master)
                            this.component = this.component_list[0];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.fetch_btn_load = false;
                        //this.order = null;
                    });
            },
            get_ay_std_ft() {
                //api-1
                this.get_ay_std_ft_loader = true;
                axios
                    .post("/feesMaster/get_ay_std_ft")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.fees_structure_data = res.data.fees_structure_data;
                            this.current_academic_year = res.data.fees_structure_data.current_academic_year;
                            this.std = this.fees_structure_data.standard_list[0];
                            this.fees_type = this.fees_structure_data.fees_deposite_type[0];
                            this.quota_list = this.fees_structure_data.quota_list[0];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.get_ay_std_ft();
        },
        watch: {
            date(val) {
                this.concession_deadline = this.formatDate(this.date);
            },
        },
        computed: {
            computedDateFormatted() {
                return this.formatDate(this.date);
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }
</style>
